class Harm {
  constructor(wrapEl) {
    this.wrapEl = wrapEl
    this.list = wrapEl.querySelectorAll('.harm__item')
  }

  calcHeight(list) {
    let res = 0
    for(let count = 0; count < list.length; count++) {
      res += list[count].offsetHeight
    }
    return res
  }

  isOpened(item) {
    return item.classList.contains('opened')
  }

  onClick(event) {
    const head = event.currentTarget
    const item = head.closest('.harm__item')
    const body = item.querySelector('.harm__body')

    const openedItem = this.wrapEl.querySelector('.opened')
    const openedHead = this.wrapEl.querySelector('.opened .harm__head')
    const isNotCurrent = openedItem !== item
    if (openedHead && isNotCurrent) {
      openedHead.click()
    }

    item.classList.toggle('opened')

    const isOpened = this.isOpened(item)

    if (isOpened) {
      const height = this.calcHeight(body.children)

      body.style.height = `${height}px`
      body.addEventListener('transitionend', () => {
        if (body.style.height) {
          body.style.height = 'auto'
        }
      }, { once: true })
    } else {
      const height = this.calcHeight(body.children)

      body.style.height = `${height}px`

      setTimeout(() => {
        body.removeAttribute('style')
      }, 0)
    }
  }

  init() {
    this.list.forEach(item => {
      const toggleBtns = item.querySelectorAll('.harm__head, .harm__btn')

      toggleBtns.forEach(btn => {
        btn.addEventListener('click', this.onClick.bind(this))
      })
    })
  }
}

const harmNodes = document.querySelectorAll('.harm')

harmNodes.forEach(item => {
  const harm = new Harm(item)
  harm.init()
})